export const AUTO_PRICE_GLOBAL_RULE_HELP =
  'Se usa cuando una variedad tiene varios precios vendibles con el mismo codigo. Al escanear ese codigo, el POS elige el formato segun estos umbrales.';

export const AUTO_PRICE_MODE_HELP =
  'Cantidad por variedad suma unidades de la misma variedad. Subtotal documento usa el subtotal acumulado antes de descuentos.';

export const AUTO_PRICE_THRESHOLD_HELP =
  'Valor minimo para que este formato califique. Si califican varios, se usa el precio calificado mas barato; si ninguno califica, queda el candidato mas alto.';

export const AUTO_PRICE_INHERIT_HELP =
  'Marcado: esta variedad usa la regla global. Desmarcado: define umbrales propios solo para esta variedad.';

export const AUTO_PRICE_CUSTOM_RULE_HELP =
  'Esta regla reemplaza la global solo para esta variedad cuando sus precios comparten barcode.';

export const AUTO_PRICE_BARCODE_GROUP_HELP =
  'Para auto-seleccionar detalle o mayorista, crea al menos dos precios vendibles de esta variedad con el mismo codigo y distintos formatos.';

export const AUTO_PRICE_BARCODE_FIELD_HELP =
  'Usa el mismo codigo en los precios que deben competir entre si. Codigos distintos se tratan como precios manuales separados.';

export const AUTO_PRICE_CLIENT_TYPE_FIELD_HELP =
  'Este formato define a que precio puede cambiar la regla. En venta sin caja, tambien debe estar permitido por el perfil sin caja.';
